import script from "./background.vue?vue&type=script&setup=true&lang=js"
export * from "./background.vue?vue&type=script&setup=true&lang=js"

import "./background.vue?vue&type=style&index=0&id=5eb7bf3c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\EDZ\\WebstormProjects\\one-nav-simple-theme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb7bf3c"]])

export default __exports__